<template>
  <div class="page-content">
    <div class="constrain-width || mobile">
      <PageHeader :goBack="() => goBack()" />
      <div class="payment">
        <PagePaymentError
          v-if="error"
          :errorMessage="error"
          :goBack="() => setError(null)"
        />
        <PagePaymentMobile
          v-else-if="pageType === pageTypes.mobilePayment"
          :updateFormState="updateFormState"
          :submitFormData="submitStripeProcess"
          :formData="mobileForm"
          :isLoading="isLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/components/PageHeader.vue";
import PagePaymentMobile from "./Payment/PageMobilePayment.vue";
import PagePaymentError from "./Error/PagePaymentError.vue";
import { mapGetters } from "vuex";
import {
  mobilePaymentFields,
  PAYMENT_FORMS,
  MODULES,
  UNITY_METHOD,
  PAGE_KEYS,
  defaultMobilePaymentFormState,
} from "@/config";
import {
  createFormState,
  denormaliseMobilePaymentForm,
  denormaliseOrderSummary,
} from "@/utils";
import { PAGE_TYPES } from "@/config";
import * as queryString from "query-string";
import { errorMixin } from "@/mixins/index.js";
export default {
  data() {
    return {
      error: null,
      isLoading: false,
      pageTypes: PAGE_TYPES,
      [PAYMENT_FORMS.mobile]: createFormState(
        mobilePaymentFields,
        defaultMobilePaymentFormState
      ),
    };
  },
  components: {
    PageHeader,
    PagePaymentMobile,
    PagePaymentError,
  },
  mixins: [errorMixin],
  mounted() {
    const { dispatch } = this.$store;

    dispatch(`${MODULES.COUNTRY}/getCountriesAction`);
    dispatch(`${MODULES.PLAN}/getPlansAction`);

    this.setInitialSearchParams((params) =>
      dispatch(`${MODULES.PAYMENT}/getSaleSummaryAction`, {
        token: params.headset_purchase_token,
        user_id: params.user_id,
        paymentType: "mobile",
      })
    );
  },
  computed: {
    ...mapGetters(MODULES.APP, {
      pageField: "getPageField",
    }),
    pageType() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.type);
    },
    pageModuleOrder() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.moduleOrder);
    },
  },
  methods: {
    goBack() {
      if (window.Unity !== undefined) {
        window.Unity.call(
          JSON.stringify({
            method: "paymentStatus",
            parameters: {
              status: UNITY_METHOD.back,
            },
          })
        );
      }
    },
    setInitialSearchParams(callback) {
      const search = location.hash.replace("#/", "");
      const whiteListedKeys = ["user_id", "headset_purchase_token"];

      if (search) {
        const obj = queryString.parse(search);

        Object.entries(obj)
          .filter((item) => whiteListedKeys.includes(item[0]))
          .forEach((entry) => {
            this.updateFormState(
              PAYMENT_FORMS.mobile,
              entry[0],
              entry[1],
              false
            );
          });

        callback(obj);
      }
    },
    handlePaymentSuccess(successData) {
      if (window.Unity !== undefined) {
        window.Unity.call(
          JSON.stringify({
            method: "paymentStatus",
            parameters: {
              status: successData?.status?.toString(),
              response_text: successData?.response_text?.toString() || null,
            },
          })
        );
      }
    },
    updateFormState(formName, field, value, touched) {
      this[formName][field] = { value, touched };

      if (field === "countryId") {
        const payload = {
          country_id: value,
        };

        this.getCountryDeliveryMethods(formName, payload);
      }
    },
    getCountryStates(id) {
      const { dispatch } = this.$store;

      dispatch(`${MODULES.COUNTRY}/getCountryStatesById`, id);
    },
    getCountryDeliveryMethods(formName, payload) {
      const { dispatch } = this.$store;

      dispatch(`${MODULES.COUNTRY}/getCountryDeliveryMethods`, payload).then(
        (data) => {
          if (data.length > 0) {
            const payload = {
              delivery_method_id: data[0].id,
              paymentType: "mobile",
            };

            this.getSaleSummary(formName, payload);
          }
        }
      );
    },
    getSaleSummary(formName, payload) {
      const { dispatch } = this.$store;

      let data = {
        ...denormaliseOrderSummary(this[formName]),
        ...payload,
        user_id: this[formName].user_id.value,
        token: this[formName].headset_purchase_token.value,
      };

      dispatch(`${MODULES.PAYMENT}/getSaleSummaryAction`, data).then(() => {
        if (payload?.delivery_method_id) {
          this.updateFormState(
            formName,
            "deliveryMethod",
            payload.delivery_method_id,
            false
          );
        }
      });
    },
    chainError(err) {
      this.isLoading = false;

      return Promise.reject(err);
    },
    submitStripeProcess: async function (stripe, paymentElement, formName) {
      const { chainError } = this;
      const { dispatch } = this.$store;

      const form = this[formName];

      const denormalisedPayload = denormaliseMobilePaymentForm(form);
      this.isLoading = true;

      await stripe
        .createPaymentMethod({
          type: "card",
          card: paymentElement,
          billing_details: {
            name: form.name.value,
          },
        })
        .then((data) =>
          dispatch(`${MODULES.PAYMENT}/submitPayment`, {
            ...denormalisedPayload,
            payment_method_id: data.paymentMethod.id,
            paymentType: "mobile",
          })
            .then((data) =>
              dispatch(`${MODULES.PAYMENT}/confirmPayment`, {
                paymentType: "mobile",
                payment_intent_id: data.payment_intent_id,
                sale_id: data.sale_id,
                sale_token: data.sale_token,
                client_secret: data.client_secret,
                requires_action: false,
              })
            )
            .then((data) => {
              this.handlePaymentSuccess(data);
              this.isLoading = false;
            })
        )
        .catch(chainError);
    },
  },
};
</script>
